import React, {forwardRef, useEffect, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import {error, REQUIRED, saveMsg, selectOption, success} from "../../../components/i18n/i18n";
import {showToastCustom} from "../../../components/toast/customToast";
import {ButtonCancel, ButtonSubmit} from "../../../components/buttons/buttonsActions";
import * as Yup from "yup";
import {useForm} from "react-hook-form";
import {showLoader} from "../../../components/loader/loader";
import Select, {makeAnimated} from "react-select";
import {benefitProvider} from "../../../providers/benefitProvider";
import {promotionBenefitService} from "../../../jwt/_services/relations/promotionBenefitService";

export const PromotionBenefitForm = forwardRef((props, ref) => {

    const animatedComponents = makeAnimated();

    const [loading, setLoading] = useState(false);

    const [promotion] = useState(props.promotion);

    const [benefitOptions, setBenefitOptions] = useState([]);
    const [benefit, setBenefit] = useState(undefined);

    useEffect(() => {
        setLoading(true);
        benefitProvider.getOptions()
            .then(result => {
                if (result){
                    setBenefitOptions(result);
                }
                else{
                    setBenefitOptions([]);
                }
                setLoading(false);
            })
            .catch(errorMessage => {
                setLoading(false);
                setBenefitOptions([]);
                showToastCustom(error, errorMessage);
            });
    }, []);

    const validationSchema = Yup.object().shape({
        showOrder: Yup.number().required(REQUIRED)
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
    });

    const onSubmit = (data, _) => {
        if (benefit == null) {
            return showToastCustom(error, selectOption);
        }
        setLoading(true);
        const dataRequest = {
            id: data.id,
            showOrder: data.showOrder,
            // Objects
            benefit: benefit,
            promotion: promotion,
        };

        //Save NO HAY MODO EDICION
        return promotionBenefitService.saveItem(dataRequest)
            .then(_ => {
                showToastCustom(success, saveMsg);
                resetForm();
            })
            .catch(errorMessage => {
                setLoading(false);
                showToastCustom(error, errorMessage);
            });
    };

    const resetForm = () => {
        setLoading(false);
        setBenefit(null);
        props.refreshList();
        reset();
    }

    // ----------------------------------------------
    //            CHANGE HANDLERS
    // ----------------------------------------------
    const onBenefitChange = (value) => {
        setBenefit(value);
    }

    return (
        <Card>
            {loading && showLoader()}
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="fas fa-clock mr-2"/>
                Beneficios de la promocion { promotion.code  ? " : " + promotion.code : "" }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label>Beneficio</Label>
                                <Select name="benefit"
                                        value={benefit}
                                        options={benefitOptions}
                                        components={animatedComponents}
                                        placeholder="Selecciona un beneficio"
                                        isSearchable={true}
                                        isClearable={true}
                                        onChange={onBenefitChange}/>
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label >Orden</Label>
                                <Input type="number" name="showOrder"
                                       innerRef={register}
                                       className={(errors.timeTo ? ' is-invalid' : '')}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonSubmit/>
                            <ButtonCancel onClick={props.setForm}/>
                        </div>
                    </CardBody>
                </Form>
            </CardBody>
        </Card>
    )
})